<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<template>
  <LImpact>
    <template #title> Security & Defence </template>
    <template #description>
      Quantum technologies could advance security and defense by providing enhanced protection of sensitive and personal information through quantum cryptography, offering unprecedented levels of data encryption. In defense, quantum advancements will potentially strengthen military capabilities with more precise detection systems, improving surveillance and early threat detection. These innovations could not only bolster national security but also ensure the safety of critical infrastructure and sensitive communications.
    </template>
    <template #image>
      <ImpactRoundedImg category-name="Security & Defence" />
    </template>
  </LImpact>
</template>

<style scoped></style>
